import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class FiOnboardingActiveService {
    constructor(private fiBackend: FiBackendService) {}
}
